import Image from 'next/image'
import dynamic from 'next/dynamic'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
const ContactForm = dynamic(() => import('./contactForm'))
const ContactInfo = dynamic(() => import('./contactInfo'))


export default function ContactMainComponent() {
    return (
        <article className='sectionOrArticleTB'>
            <div className='text-center'>
                <h1 className='caregoriesTitle'>Contact Fl Gold Coin Exchange</h1>
            </div>
            <article className='sectionOrArticleB'>
                <div className='imgStripContainer'>
                    <div className='imgStripText'>
                        <Image src='/images/Strip5.gif'
                            alt="Strip"
                            fill
                            sizes="(max-width: 768px) 100vw,
                        (max-width: 1200px) 50vw,
                        33vw"
                        />
                    </div>
                </div>
            </article>
            <article className='sectionOrArticleTB mt-5 mt-lg-0 mt-xl-0 mt-xxl-0'>
                <Container>
                    <Row>
                        <Col>                            
                            <p className=''>
                                We are to assist you with questions you may have about collectable coins.
                                Please fill up the form, and we will contact you as soon as possible.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} md={6} >
                            <ContactInfo />
                        </Col>
                        <Col xs={12} md={6}>
                            <ContactForm />
                        </Col>
                    </Row>
                </Container>
            </article>
        </article>
    )
}